import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Tabs/src/TabBar.js",
    _this = this;

import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import TabContext from './TabContext';
import useDevice from '../../../core/hooks/useDevice';
import { withOpacity } from '../../../helpers';
import { scrollElement } from '../../../helpers/smoothScrollingPolyfill';
import { withWindowSize } from '../../../core/hooks/windowSize';
import { ArrowLeft, ArrowRight } from '@dls/assets/icons';
import { withTheme, useTheme } from '../../../core/ThemeProvider';

var TabBar = function TabBar(_ref) {
  var selected = _ref.selected,
      onTabItemClick = _ref.onTabItemClick,
      children = _ref.children,
      windowSize = _ref.windowSize,
      secondary = _ref.secondary;

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var _useDevice = useDevice(),
      isMobile = _useDevice.isMobile;

  var indicatorRef = useRef(null);
  var tabsContainerRef = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      indicatorEl = _useState2[0],
      setIndicatorEl = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      tabsContainerEl = _useState4[0],
      setTabsContainerEl = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      shouldShowLeftArrow = _useState6[0],
      setShouldShowLeftArrow = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      shouldShowRightArrow = _useState8[0],
      setShouldShowRightArrow = _useState8[1];

  var arrowTriggerOffset = 40;
  useEffect(function () {
    setIndicatorEl(indicatorRef.current);
  }, [indicatorRef]);
  useEffect(function () {
    setTabsContainerEl(tabsContainerRef.current);
  }, [tabsContainerRef]);
  useEffect(function () {
    tabsContainerEl && toggleArrows(tabsContainerEl);
  }, [tabsContainerEl, isMobile, windowSize]);

  var onTabBarContainerScroll = function onTabBarContainerScroll(container) {
    toggleArrows(container);
  };

  var toggleArrows = function toggleArrows(container) {
    var showLeftArrow = !isMobile && container.scrollLeft > arrowTriggerOffset;
    setShouldShowLeftArrow(showLeftArrow);
    var showRightArrow = !isMobile && container.scrollWidth - (container.offsetWidth + container.scrollLeft) > arrowTriggerOffset;
    setShouldShowRightArrow(showRightArrow);
  };

  var onArrowClick = function onArrowClick(side) {
    tabsContainerRef && tabsContainerRef.current.scrollTo && scrollElement(tabsContainerRef.current, {
      left: side === 'left' ? 0 : tabsContainerRef.current.clientWidth,
      behavior: 'smooth'
    });
  };

  return /*#__PURE__*/React.createElement(Container, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TabBarContainer, {
    "data-testid": "tabbar-container",
    ref: tabsContainerRef,
    onScroll: function onScroll(e) {
      return onTabBarContainerScroll(e.target);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(TabBarDivider, {
    secondary: secondary,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(TabsContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 9
    }
  }, React.Children.map(children, function (c, i) {
    return /*#__PURE__*/React.createElement(TabContext.Provider, {
      key: i,
      value: {
        isMobile: isMobile,
        index: i,
        isSelected: i === selected,
        onItemClick: onTabItemClick,
        indicatorEl: indicatorEl,
        tabsContainerEl: tabsContainerEl,
        windowSize: windowSize,
        secondary: secondary
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 77,
        columnNumber: 13
      }
    }, c);
  })), /*#__PURE__*/React.createElement(TabItemIndicator, {
    secondary: secondary,
    ref: indicatorRef,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(ArrowWrapper, {
    onClick: function onClick() {
      return onArrowClick('left');
    },
    opacity: shouldShowLeftArrow ? 1 : 0,
    "data-testid": "left-arrow",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ArrowHighlight, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ArrowLeft, {
    size: 22,
    color: theme.cl_sec_d1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(ArrowWrapper, {
    onClick: function onClick() {
      return onArrowClick('right');
    },
    opacity: shouldShowRightArrow ? 1 : 0,
    rightPosition: true,
    "data-testid": "right-arrow",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ArrowHighlight, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    size: 22,
    color: theme.cl_sec_d1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 11
    }
  }))));
};

export var TabBarPropTypes = {
  /**
   * Index of the selected tab
   */
  selected: PropTypes.number,

  /**
   * secondary style for tab
   */
  secondary: PropTypes.bool,

  /**
   * Callback for handling click events on each the tab item.
   */
  onTabItemClick: PropTypes.func
};
TabBar.defaultProps = {};
export default withWindowSize(TabBar);
var TabsContainer = withTheme(styled.div.withConfig({
  displayName: "TabBar__TabsContainer",
  componentId: "sc-dd6i3-0"
})(function (_ref2) {
  var coreTheme = _ref2.coreTheme;
  return css(["position:relative;display:table;width:", ";"], coreTheme.tab.tabContainerWidth ? coreTheme.tab.tabContainerWidth : '100%');
}));
var TabItemIndicator = withTheme(styled.div.withConfig({
  displayName: "TabBar__TabItemIndicator",
  componentId: "sc-dd6i3-1"
})(function (_ref3) {
  var _coreTheme$tab$second;

  var coreTheme = _ref3.coreTheme,
      secondary = _ref3.secondary;
  return css(["position:absolute;left:0;bottom:", ";width:0;height:4px;border-radius:2px;background-color:", ";", ""], coreTheme.tab.tabBarDividerPositionBottom, coreTheme.tab.tabItemIndicatorBgColor, secondary && css(["background-color:", ";"], (_coreTheme$tab$second = coreTheme.tab.secondary) === null || _coreTheme$tab$second === void 0 ? void 0 : _coreTheme$tab$second.tabItemIndicatorBgColor));
}));
export var TabBottomBorder = styled.div.withConfig({
  displayName: "TabBar__TabBottomBorder",
  componentId: "sc-dd6i3-2"
})(["height:4px;width:100%;position:absolute;bottom:0;left:0;border-radius:2px;"]);
var TabBarDivider = withTheme(styled(TabBottomBorder).withConfig({
  displayName: "TabBar__TabBarDivider",
  componentId: "sc-dd6i3-3"
})(function (_ref4) {
  var _coreTheme$tab$second2;

  var coreTheme = _ref4.coreTheme,
      secondary = _ref4.secondary;
  return css(["position:absolute;bottom:", ";background-color:", ";", ""], coreTheme.tab.tabBarDividerPositionBottom, coreTheme.tab.tabBarDividerBgColor, secondary && coreTheme.tab.secondary && css(["background-color:", ";"], (_coreTheme$tab$second2 = coreTheme.tab.secondary) === null || _coreTheme$tab$second2 === void 0 ? void 0 : _coreTheme$tab$second2.tabBarDividerBgColor));
}));
var TabBarContainer = withTheme(styled.div.withConfig({
  displayName: "TabBar__TabBarContainer",
  componentId: "sc-dd6i3-4"
})(function (_ref5) {
  var coreTheme = _ref5.coreTheme;
  return css(["position:relative;overflow:auto;width:100%;text-transform:", ";padding-bottom:", ";scrollbar-width:none;border-radius:", ";::-webkit-scrollbar{display:none;}"], coreTheme.tab.textTransform, coreTheme.tab.tabBarContainerPaddingBottom, coreTheme.tab.TabBarContainerBorderRadius);
}));
var Container = styled.div.withConfig({
  displayName: "TabBar__Container",
  componentId: "sc-dd6i3-5"
})(["position:relative;display:flex;"]);
var ArrowWrapper = withTheme(styled.div.withConfig({
  displayName: "TabBar__ArrowWrapper",
  componentId: "sc-dd6i3-6"
})(["position:absolute;cursor:pointer;height:100%;pointer-events:", ";background-color:", ";opacity:", ";transition:opacity 0.2s;", ";"], function (p) {
  return p.opacity === 0 ? 'none' : 'all';
}, function (p) {
  return p.coreTheme.cl_white;
}, function (p) {
  return p.coreTheme.tab.hideScrollArrow ? 0 : p.opacity;
}, function (p) {
  return p.rightPosition && 'right: 0';
}));
var ArrowHighlight = withTheme(styled.div.withConfig({
  displayName: "TabBar__ArrowHighlight",
  componentId: "sc-dd6i3-7"
})(["display:flex;align-items:center;height:100%;", ""], function (p) {
  return css(["&:hover{background-color:", ";}"], withOpacity(p.coreTheme.cl_sec_l1, 0.8));
}));